export enum EndpointTypes {
  CHAT_GPT_ASK = "CHAT_GPT_ASK",
  CHAT_GPT_RESET = "CHAT_GPT_RESET",
  LOGIN = "LOGIN",
  USER_CURRENT = "USER_CURRENT",
  USER_CURRENT_ROLE = "USER_CURRENT_ROLE",
  USER_CURRENT_TIME_ZONE = "USER_CURRENT_TIME_ZONE",
  USER_CURRENT_PROFILE = "USER_CURRENT_PROFILE",
  USER_CURRENT_ACCOUNTS = "USER_CURRENT_ACCOUNTS",
  USER_CURRENT_PICTURE = "USER_CURRENT_PICTURE",
  USER_CURRENT_PROJECTS_BY_ACCOUNT = "USER_CURRENT_PROJECTS_BY_ACCOUNT",
  UPDATE_PROFILE_SETTINGS = "UPDATE_PROFILE_SETTINGS",
  GET_USERS = "GET_USERS",
  GET_USERS_EXTENDED = "GET_USERS_EXTENDED",
  GET_USER_BY_ID = "GET_USER_BY_ID",
  ACCOUNT_CHECK = "ACCOUNT_CHECK",
  ACCOUNT_ENABLE = "ACCOUNT_ENABLE",
  ACCOUNT_TEST = "ACCOUNT_TEST",
  GET_ACCOUNT = "GET_ACCOUNT",
  UPDATE_ACCOUNT = "UPDATE_ACCOUNT",
  GET_ACCOUNTS = "GET_ACCOUNTS",
  ACCOUNT_RESOLVE = "ACCOUNT_RESOLVE",
  POST_ACCOUNT = "POST_ACCOUNT",
  START_SUBSCRIPTION = "START_SUBSCRIPTION",
  CONFIRM_SUBSCRIPTION = "CONFIRM_SUBSCRIPTION",
  GET_ITEMS = "GET_ITEMS",
  POST_ITEM = "POST_ITEM",
  ITEM_VALIDATE_CREATE_CHECK = "ITEM_VALIDATE_CREATE_CHECK",
  ITEM_VALIDATE_CHANGE_CHECK = "ITEM_VALIDATE_CHANGE_CHECK",
  GET_ITEM_FILES = "GET_ITEM_FILES",
  DELETE_ITEM_FILE = "DELETE_ITEM_FILE",
  RESOLVE_ITEM_ID = "RESOLVE_ITEM_ID",
  GET_COMMENTS = "GET_COMMENTS",
  GET_COMMENT = "GET_COMMENT",
  GET_COMMENTS_BY_SOURCE = "GET_COMMENTS_BY_SOURCE",
  POST_COMMENT = "POST_COMMENT",
  UPDATE_COMMENT_DESCRIPTION = "UPDATE_COMMENT_DESCRIPTION",
  PROJECT = "PROJECT",
  PROJECT_BY_ID = "PROJECT_BY_ID",
  PROJECT_FAVORITE = "PROJECT_FAVORITE",
  PROJECT_TEAM_DASHBOARD_HIDDEN = "PROJECT_TEAM_DASHBOARD_HIDDEN",
  PROJECT_SEARCH = "PROJECT_SEARCH",
  ADD_PROJECT_TO_TEAM = "ADD_PROJECT_TO_TEAM",
  ATTACHMENT_UPLOAD = "ATTACHMENT_UPLOAD",
  ATTACHMENT_UPLOAD_TARGET = "ATTACHMENT_UPLOAD_TARGET",
  ATTACHMENT_UPLOAD_ITEM_DEMO_VIDEO = "ATTACHMENT_UPLOAD_ITEM_DEMO_VIDEO",
  GET_DEMO_VIDEOS = "GET_DEMO_VIDEOS",
  CREATE_DEMO_VIDEO = "CREATE_DEMO_VIDEO",
  DELETE_DEMO_VIDEO = "DELETE_DEMO_VIDEO",
  DELETE_FILE = "DELETE_FILE",
  TEAM = "TEAM",
  TEAM_FAVORITE = "TEAM_FAVORITE",
  TEAMS = "TEAMS",
  TEAM_RESOLVE = "TEAM_RESOLVE",
  INVITATION = "INVITATION",
  INVITATION_WITH_FEEDBACK = "INVITATION_WITH_FEEDBACK",
  INVITATION_RESEND_BY_ID = "INVITATION_RESEND_BY_ID",
  INVITATION_RESEND_BY_EMAIL = "INVITATION_RESEND_BY_EMAIL",
  INVITATION_ACCEPT = "INVITATION_ACCEPT",
  INVITATION_CANCEL = "INVITATION_CANCEL",
  INVITATION_CHECK = "INVITATION_CHECK",
  INVITATION_WITH_TEAM_CHECK = "INVITATION_WITH_TEAM_CHECK",
  INVITATION_UPDATE_TEAM_ROLE = "INVITATION_UPDATE_TEAM_ROLE",
  TEAM_PICTURE = "TEAM_PICTURE",
  TEAM_USER_ADD = "TEAM_USER_ADD",
  TEAM_USER_DELETE = "TEAM_USER_DELETE",
  TEAM_USER_UPDATE_ROLE = "TEAM_USER_UPDATE_ROLE",
  PICTURE = "PICTURE",
  BACKLOG = "BACKLOG",
  CHANGE_ITEM_PRIORITY = "CHANGE_ITEM_PRIORITY",
  GET_ITEM_CURRENT_POSITION = "GET_ITEM_CURRENT_POSITION",
  CHANGE_ITEM_PRIORITY_BATCH = "CHANGE_ITEM_PRIORITY_BATCH",
  TEAM_IN_PROJECT = "TEAM_IN_PROJECT",
  GET_EPIC = "GET_EPIC",
  GET_EPICS_FILTER_TEAMS = "GET_EPICS_FILTER_TEAMS",
  GET_EPICS = "GET_EPICS",
  POST_EPIC = "POST_EPIC",
  UPDATE_EPIC = "UPDATE_EPIC",
  CHANGE_EPIC_PRIORITY = "CHANGE_EPIC_PRIORITY",
  CHANGE_EPIC_PRIORITY_IN_MILESTONE = "CHANGE_EPIC_PRIORITY_IN_MILESTONE",
  MOVE_EPIC_TO_MILESTONE = "MOVE_EPIC_TO_MILESTONE",
  EPIC_MILESTONE_PLANNING = "EPIC_MILESTONE_PLANNING",
  GET_EPIC_MILESTONE_PLANNING = "GET_EPIC_MILESTONE_PLANNING",
  GET_EPIC_CURRENT_POSITION = "GET_EPIC_CURRENT_POSITION",
  SPRINTS = "SPRINTS",
  SPRINT = "SPRINT",
  SPRINT_NOT_COMPLETED = "SPRINT_NOT_COMPLETED",
  SPRINT_METRICS = "SPRINT_METRICS",
  SPRINT_START = "SPRINT_START",
  SPRINT_COMPLETE = "SPRINT_COMPLETE",
  SPRINT_HALT = "SPRINT_HALT",
  SPRINTS_WITH_STATS = "SPRINTS_WITH_STATS",
  SPRINT_START_REVIEW = "SPRINT_START_REVIEW",
  SPRINT_COMPLETE_REVIEW = "SPRINT_COMPLETE_REVIEW",
  CAN_START_SPRINT = "CAN_START_SPRINT",
  SPRINT_REVIEW = "SPRINT_REVIEW",
  RESOLVE_SPRINT_ID = "RESOLVE_SPRINT_ID",
  ITEM_DEFINITION_OF_DONE = "ITEM_DEFINITION_OF_DONE",
  GET_STORY_POKER = "GET_STORY_POKER",
  CREATE_STORY_POKER = "CREATE_STORY_POKER",
  ASSIGN_EPIC = "ASSIGN_EPIC",
  GET_ITEMS_SNAPSHOT_BY_EPIC_V2 = "GET_ITEMS_SNAPSHOT_BY_EPIC_V2",
  DELETE_ITEM_FROM_EPIC = "DELETE_ITEM_FROM_EPIC",
  RESOLVE_EPIC_ID = "RESOLVE_EPIC_ID",
  METRICS_EPIC = "METRICS_EPIC",
  METRICS_BUG = "METRICS_BUG",
  METRICS_BACKLOG = "METRICS_BACKLOG",
  METRICS_TEAM_BACKLOGS = "METRICS_TEAM_BACKLOGS",
  TODO = "TODO",
  TODO_ITEM = "TODO_ITEM",
  TODO_COUNT = "TODO_COUNT",
  TODO_METRICS = "TODO_METRICS",
  GET_MILESTONE = "GET_MILESTONE",
  STOP_MILESTONE = "STOP_MILESTONE",
  GET_MILESTONES = "GET_MILESTONES",
  MILESTONES_PERIOD = "MILESTONES_PERIOD",
  POST_MILESTONE = "POST_MILESTONE",
  POST_MILESTONE_EPIC = "POST_MILESTONE_EPIC",
  GET_ALL_USERS = "GET_ALL_USERS",
  GET_ALL_USERS_SUPERADMIN = "GET_ALL_USERS_SUPERADMIN",
  USER_BY_ID = "USER_BY_ID",
  USER_ADD_PROJECT = "USER_ADD_PROJECT",
  USER_DEACTIVATION = "USER_DEACTIVATION",
  USER_PERMISSIONS = "USER_PERMISSIONS",
  ADMIN_USER_EMAIL_SUPPRESSION = "ADMIN_USER_EMAIL_SUPPRESSION",
  CHANGE_STATUS_ITEM = "CHANGE_STATUS_ITEM",
  CHANGE_OWNER_ITEM = "CHANGE_OWNER_ITEM",
  PROJECT_OVERVIEW = "PROJECT_OVERVIEW",
  PROJECT_OVERVIEW_SEARCH = "PROJECT_OVERVIEW_SEARCH",
  PROJECT_OVERVIEW_BY_ID = "PROJECT_OVERVIEW_BY_ID",
  SPRINT_WITH_STATS = "SPRINT_WITH_STATS",
  SPRINT_WITH_STATS_FULL = "SPRINT_WITH_STATS_FULL",
  GET_SUBSCRIPTION = "GET_SUBSCRIPTION",
  SET_SUBSCRIPTION = "SET_SUBSCRIPTION",
  GET_SUBSCRIPTION_TOKEN = "GET_SUBSCRIPTION_TOKEN",
  STREAM_SUBSCRIPTION = "STREAM_SUBSCRIPTION",
  FIVE_WHYS = "FIVE_WHYS",
  FIVE_WHYS_BY_ID = "FIVE_WHYS_BY_ID",
  GET_EMAIL_TEMPLATES = "GET_EMAIL_TEMPLATES",
  GET_EMAIL_TEMPLATE_TYPE = "GET_EMAIL_TEMPLATES_TYPE",
  POST_EMAIL_TEMPLATE_RENDER = "POST_EMAIL_TEMPLATE_RENDER",
  EMAIL_SEND = "EMAIL_SEND",
  MOVE_TO_ITEM = "MOVE_TO_ITEM",
  SEARCH = "SEARCH",
  SEARCH_ITEM = "SEARCH_ITEM",
  SEARCH_PROJECT = "SEARCH_PROJECT",
  SEARCH_SPRINT = "SEARCH_SPRINT",
  SEARCH_EPIC = "SEARCH_EPIC",
  SEARCH_IDEA = "SEARCH_IDEA",
  SEARCH_TEAM = "SEARCH_TEAM",
  CHECK_TEAM_NAME = "CHECK_TEAM_NAME",
  SEARCH_MILESTONE = "SEARCH_MILESTONE",
  SEARCH_LABELS = "SEARCH_LABELS",
  SEARCH_ACCOUNT_LABELS = "SEARCH_ACCOUNT_LABELS",
  TASKS_LIST = "TASKS_LIST",
  TASKS_ORDER = "TASKS_ORDER",
  GET_SPRINT_NUMBER = "GET_SPRINT_NUMBER",
  LOG_METRIC_PAGELOAD = "LOG_METRIC_PAGELOAD",
  LOG_ERROR = "LOG_ERROR",
  PROJECT_RESOLVE = "PROJECT_RESOLVE",
  UPDATE_ITEM_DETAILS = "UPDATE_ITEM_DETAILS",
  UPDATE_TEAM = "UPDATE_TEAM",
  UPDATE_ITEM_TEAM_TYPE = "UPDATE_ITEM_TEAM_TYPE",
  GET_ITEM_TEAM_TYPES = "GET_ITEM_TEAM_TYPES",
  IMPORT_ITEM_TO_EPIC = "IMPORT_ITEM_TO_EPIC",
  ARCHIVE_EPIC = "ARCHIVE_EPIC",
  MERGE_EPIC = "MERGE_EPIC",
  ADD_STORY_POKER_ESTIMATION = "ADD_STORY_POKER_ESTIMATION",
  RESTORE_EPIC = "RESTORE_EPIC",
  GET_NOTIFICATIONS = "GET_NOTIFICATIONS",
  SUBMIT_ERROR_REPORT = "SUBMIT_ERROR_REPORT",
  NOTIFICATIONS_MARK_AS_READ = "NOTIFICATIONS_MARK_AS_READ",
  GET_PROJECT_WITH_STATS_TEAM = "GET_PROJECT_WITH_STATS_TEAM",
  GET_PROJECT_WITH_STATS_USER = "GET_PROJECT_WITH_STATS_USER",
  TEAM_CREATE_WITH_USERS = "TEAM_CREATE_WITH_USERS",
  TEAMS_WITH_USERS_SEARCH = "TEAMS_WITH_USERS_SEARCH",
  TEAMS_SEARCH_ADMIN = "TEAMS_SEARCH_ADMIN",
  TEAM_UPDATE_ADMIN = "TEAM_UPDATE_ADMIN",
  TEAM_HAS_ACTIVE_SPRINT = "TEAM_HAS_ACTIVE_SPRINT",
  GET_ACCOUNT_SUPERADMIN = "GET_ACCOUNT_SUPERADMIN",
  ACCOUNT_PICTURE = "ACCOUNT_PICTURE",
  COMPLETE_STORY_POKER = "COMPLETE_STORY_POKER",
  TEAM_WITH_EXTENDED_USERS = "TEAM_WITH_EXTENDED_USERS",
  RETROSPECTIVE_COMPLETE = "RETROSPECTIVE_COMPLETE",
  RETROSPECTIVE_REVEAL = "RETROSPECTIVE_REVEAL",
  RETROSPECTIVE_POST = "RETROSPECTIVE_POST",
  RETROSPECTIVE_CHANGE_PRIORITY = "RETROSPECTIVE_CHANGE_PRIORITY",
  GET_RETROSPECTIVE = "GET_RETROSPECTIVE",
  GET_RETROSPECTIVE_INSIGHTS = "GET_RETROSPECTIVE_INSIGHTS",
  GET_RETROSPECTIVE_STATUS = "GET_RETROSPECTIVE_STATUS",
  RETROSPECTIVE_PUT_STACK = "RETROSPECTIVE_PUT_STACK",
  RETROSPECTIVE_POST_STACK = "RETROSPECTIVE_POST_STACK",
  RETROSPECTIVE_POST_STACK_NOTE = "RETROSPECTIVE_POST_STACK_NOTE",
  RETROSPECTIVE_PUT_NOTE = "RETROSPECTIVE_PUT_NOTE",
  RETROSPECTIVE_REVIEWED = "RETROSPECTIVE_REVIEWED",
  RETROSPECTIVE_NOTES = "RETROSPECTIVE_NOTES",
  GET_RETROSPECTIVE_BY_SPRINT_ID = "GET_RETROSPECTIVE_BY_SPRINT_ID",
  ADMIN_PROJECT_SEARCH = "ADMIN_PROJECT_SEARCH",
  ACCOUNT_CONTACT_INFO = "ACCOUNT_CONTACT_INFO",
  GOAL = "GOAL",
  CHANGE_GOAL_PRIORITY = "CHANGE_GOAL_PRIORITY",
  ADD_SPECIFIC_FEATURE = "ADD_SPECIFIC_FEATURE",
  GET_FEATURE_BY_GOAL = "GET_FEATURE_BY_GOAL",
  FEATURE_GOAL = "FEATURE_GOAL",
  FEATURE = "FEATURE",
  CHANGE_FEATURE_PRIORITY = "CHANGE_FEATURE_PRIORITY",
  ADD_PROJECT_FEATURE = "ADD_PROJECT_FEATURE",
  UPDATE_FEATURE = "UPDATE_FEATURE",
  DELETE_FEATURE = "DELETE_FEATURE",
  GET_FEATURE_EPICS = "GET_FEATURE_EPICS",
  UPDATE_FEATURE_EPIC = "UPDATE_FEATURE_EPIC",
  USER_PICTURE_UPDATE = "USER_PICTURE_UPDATE",
  USER_SETTINGS = "USER_SETTINGS",
  ADMIN_USER_BY_ID = "ADMIN_USER_BY_ID",
  SUPERADMIN_USER_BY_ID = "SUPERADMIN_USER_BY_ID",
  STRIPE_GET_PRODUCTS = "STRIPE_GET_PRODUCTS",
  STRIPE_GET_PRICES = "STRIPE_GET_PRICES",
  STRIPE_SUBSCRIBE = "STRIPE_SUBSCRIBE",
  PAYMENT_SUBSCRIPTION_START = "PAYMENT_SUBSCRIPTION_START",
  PAYMENT_SUBSCRIPTION_START_TRIAL = "PAYMENT_SUBSCRIPTION_START_TRIAL",
  SPRINT_QUOTE = "SPRINT_QUOTE",
  ITEMS_METRICS = "ITEMS_METRICS",
  CHANGE_MILESTONE_DURATION = "CHANGE_MILESTONE_DURATION",
  GET_MILESTONES_REVIEW = "GET_MILESTONES_REVIEW",
  GET_ACCOUNT_ADMIN = "GET_ACCOUNT_ADMIN",
  PROJECT_OVERVIEW_AT_RISK = "PROJECT_OVERVIEW_AT_RISK",
  EMAIL_VERIFICATION_SEND = "EMAIL_VERIFICATION_SEND",
  EMAIL_VERIFICATION_RESEND = "EMAIL_VERIFICATION_RESEND",
  SPRINT_EXISTS_CONTINUOUS = "SPRINT_EXISTS_CONTINUOUS",
  DEFINITION_OF_DONE = "DEFINITION_OF_DONE",
  METRICS_BY_TYPE = "METRICS_BY_TYPE",
  EDIT_SUMMARY = "EDIT_SUMMARY",
  UPDATE_ITEM_READINESS = "UPDATE_ITEM_READINESS",
  GET_LIST_OF_RETROSPECTIVE = "GET_LIST_OF_RETROSPECTIVE",
  RETROSPECTIVE_START = "RETROSPECTIVE_START",
  LIST_OF_MILESTONE_CHARTS = "LIST_OF_MILESTONE_CHARTS",
  CHANGE_TEAM_FOR_ITEMS_BATCH = "CHANGE_TEAM_FOR_ITEMS_BATCH",
  GET_COMMENT_COUNT = "GET_COMMENT_COUNT",
  CREATE_DEMO_PROJECT = "CREATE_DEMO_PROJECT",
  RECREATE_DEMO_PROJECT = "RECREATE_DEMO_PROJECT",
  RECREATE_DEMO_PROJECT_START = "RECREATE_DEMO_PROJECT_START",
  GET_DEMO_PROJECTS = "GET_DEMO_PROJECTS",
  DELETE_PROJECT = "DELETE_PROJECT",
  SAVE_HEALTH_CHECK = "SAVE_HEALTH_CHECK",
  SEARCH_FEATURE = "SEARCH_FEATURE",
  POST_GOAL = "POST_GOAL",
  GET_GOALS_LIST = "GET_GOALS_LIST",
  SEARCH_GOAL = "SEARCH_GOAL",
  GOAL_STATUS_COUNTS = "GOAL_STATUS_COUNTS",
  GET_GOAL = "GET_GOAL",
  GET_EXTENDED_GOAL = "GET_EXTENDED_GOAL",
  UPDATE_EXTENDED_GOAL = "UPDATE_EXTENDED_GOAL",
  DELETE_GOAL_ATTACHMENT = "DELETE_GOAL_ATTACHMENT",
  HEALTH_CHECK_SUMMARY = "HEALTH_CHECK_SUMMARY",
  TODO_ITEM_RESOLVE = "TODO_ITEM_RESOLVE",
  TODO_ITEM_UNRESOLVE = "TODO_ITEM_UNRESOLVE",
  TODO_ITEM_DELETE_ATTACHMENT = "TODO_ITEM_DELETE_ATTACHMENT",
  METRICS_SEVERITY = "METRICS_SEVERITY",
  ATTACHMENT_UPLOAD_TARGET_BY_ACCOUNT = "ATTACHMENT_UPLOAD_TARGET_BY_ACCOUNT",
  ATTACHMENT_UPLOAD_BY_ACCOUNT = "ATTACHMENT_UPLOAD_BY_ACCOUNT",
  ATTACHMENT_BY_ACCOUNT = "ATTACHMENT_BY_ACCOUNT",
  ATTACHMENT_DOCUMENT_PREVIEW_BY_ACCOUNT = "ATTACHMENT_DOCUMENT_PREVIEW_BY_ACCOUNT",
  ATTACHMENT_FILE_METADATA = "ATTACHMENT_FILE_METADATA",
  ATTACHMENT_DOWNLOAD_BY_ACCOUNT = "ATTACHMENT_DOWNLOAD_BY_ACCOUNT",
  DELETE_ATTACHMENT_BY_ACCOUNT = "DELETE_ATTACHMENT_BY_ACCOUNT",
  DELETE_ATTACHMENT_FROM_TARGET = "DELETE_ATTACHMENT_FROM_TARGET",
  ATTACHMENT_METADATA = "ATTACHMENT_METADATA",
  ATTACHMENT_VIDEO_URL = "ATTACHMENT_VIDEO_URL",
  ATTACHMENT_STREAM_TOKEN = "ATTACHMENT_STREAM_TOKEN",
  ATTACHMENT_DIRECT_UPLOAD_START = "ATTACHMENT_DIRECT_UPLOAD_START",
  ATTACHMENT_DIRECT_UPLOAD_PART = "ATTACHMENT_DIRECT_UPLOAD_PART",
  ATTACHMENT_DIRECT_UPLOAD_COMPLETE = "ATTACHMENT_DIRECT_UPLOAD_COMPLETE",
  ATTACHMENT_DIRECT_UPLOAD_CANCEL = "ATTACHMENT_DIRECT_UPLOAD_CANCEL",
  GET_STORY_POKER_URL = "GET_STORY_POKER_URL",
  ACCOUNT_CONTACT_INFO_SUPER_ADMIN = "ACCOUNT_CONTACT_INFO_SUPER_ADMIN",
  SPRINT_CAPACITY = "SPRINT_CAPACITY",
  SPRINT_CONTEXT = "SPRINT_CONTEXT",
  MY_WORK_CHANGE_PRIORITY = "MY_WORK_CHANGE_PRIORITY",
  MY_WORK_PRIORITIZED = "MY_WORK_PRIORITIZED",
  SPRINT_TIME_OFFS = "SPRINT_TIME_OFFS",
  CHECK_EXIST_PROJECT_BY_URL_OR_NAME = "CHECK_EXIST_PROJECT_BY_URL_OR_NAME",
  TASKS_ESTIMATION = "TASKS_ESTIMATION",
  JIRA_IMPORT_START = "JIRA_IMPORT_START",
  JIRA_IMPORT_STATUS = "JIRA_IMPORT_STATUS",
  JIRA_IMPORT_USERS_START = "JIRA_IMPORT_USERS_START",
  JIRA_IMPORT_USERS = "JIRA_IMPORT_USERS",
  JIRA_IMPORT_BACKLOG_START = "JIRA_IMPORT_BACKLOG_START",
  JIRA_IMPORT_BACKLOG_FINISH = "JIRA_IMPORT_BACKLOG_FINISH",
  JIRA_IMPORT_BACKLOG_SYNC_ENABLE = "JIRA_IMPORT_BACKLOG_SYNC_ENABLE",
  JIRA_IMPORT_BACKLOG_SYNC_DISABLE = "JIRA_IMPORT_BACKLOG_SYNC_DISABLE",
  UPDATE_STATUS_DESCRIPTION = "UPDATE_STATUS_DESCRIPTION",
  BACKLOG_ANALYTICS = "BACKLOG_ANALYTICS",
  BACKLOG_ITEMS_AGE = "BACKLOG_ITEMS_AGE",
  ADD_TEAMS_TO_PROJECT = "ADD_TEAMS_TO_PROJECT",
  INVITE_TO_TEAM_LINK = "INVITE_TO_TEAM_LINK",
  SPRINT_ANALYTICS = "SPRINT_ANALYTICS",
  SPRINT_ANALYTICS_PERFORMANCE = "SPRINT_ANALYTICS_PERFORMANCE",
  SPRINT_ANALYTICS_QUALITY = "SPRINT_ANALYTICS_QUALITY",
  SPRINT_ANALYTICS_OVERVIEW = "SPRINT_ANALYTICS_OVERVIEW",
  SPRINT_ANALYTICS_TEAM_INSIGHTS = "SPRINT_ANALYTICS_TEAM_INSIGHTS",
  TIME_SHEET = "TIME_SHEET",
  GET_TIME_SHEET = "GET_TIME_SHEET",
  TIME_SHEET_ENTRIES = "TIME_SHEET_ENTRIES",
  TIME_SHEET_SUBMIT = "TIME_SHEET_SUBMIT",
  TIME_SHEET_DECLINE = "TIME_SHEET_DECLINE",
  TIME_SHEET_APPROVE = "TIME_SHEET_APPROVE",
  TIME_SHEET_SUMMARY = "TIME_SHEET_SUMMARY",
  TIME_SHEET_SEARCH = "TIME_SHEET_SEARCH",
  TIME_SHEET_STATS = "TIME_SHEET_STATS",
  TIME_SHEET_CURRENT = "TIME_SHEET_CURRENT",
  TIME_SHEET_PERIOD_WEEKS = "TIME_SHEET_PERIOD_WEEKS",
  TIME_SHEET_PERIOD_MONTH = "TIME_SHEET_PERIOD_MONTH",
  TIME_SHEET_USERS_ENABLED = "TIME_SHEET_USERS_ENABLED",
  MANAGE_JIRA_USER_TOKEN = "MANAGE_JIRA_USER_TOKEN",
  CHECK_WIP_LIMIT = "CHECK_WIP_LIMIT",
  IS_WIP_LIMIT_VALID = "IS_WIP_LIMIT_VALID",
  SEARCH_ITEM_WITH_TASKS = "SEARCH_ITEM_WITH_TASKS",
  GET_TIME_SHEET_SUMMARY_EXCEL = "GET_TIME_SHEET_SUMMARY_EXCEL",
  TIME_SHEET_SUMMARY_WEEKS = "TIME_SHEET_SUMMARY_WEEKS",
  TIME_SHEET_CHANGE_HISTORY = "TIME_SHEET_CHANGE_HISTORY",
  GET_ITEM_ANALYTICS = "GET_ITEM_ANALYTICS",
  TIME_SHEET_PERIOD_AVAILABLE_WEEKS = "TIME_SHEET_PERIOD_AVAILABLE_WEEKS",
  CHANGE_SPRINT_PRIORITY = "CHANGE_SPRINT_PRIORITY",
  TASKS_PROVIDED = "TASKS_PROVIDED",
  DELETE_TASK = "DELETE_TASK",
  SPRINT_ANALYTICS_HEALTH_CHECK = "SPRINT_ANALYTICS_HEALTH_CHECK",
  GET_DEMO_REQUESTS = "GET_DEMO_REQUESTS",
  GET_ACCOUNTS_ANALYTICS = "GET_ACCOUNTS_ANALYTICS",
  DELETE_DEMO_REQUESTS = "DELETE_DEMO_REQUESTS",
  GET_ITEM_PRIORITY = "GET_ITEM_PRIORITY",
  PROJECT_OVERVIEW_EXTENDED = "PROJECT_OVERVIEW_EXTENDED",
  PROJECT_OVERVIEW_EXTENDED_SEARCH = "PROJECT_OVERVIEW_EXTENDED_SEARCH",
  GET_SIMPLIFY_MILESTONES = "GET_SIMPLIFY_MILESTONES",
  GET_MILESTONE_EXCLUDING_COMING_STATUS = "GET_MILESTONE_EXCLUDING_COMING_STATUS",
  SPRINTS_WITH_STATS_EXTENDED = "SPRINTS_WITH_STATS_EXTENDED",
  RESTORE_TASK = "RESTORE_TASK",
  TEAM_WITH_AUTHORIZED_USERS = "TEAM_WITH_AUTHORIZED_USERS",
  SEARCH_ITEM_QUERY = "SEARCH_ITEM_QUERY",
  ITEMS_METRICS_BY_ACCOUNT = "ITEMS_METRICS_BY_ACCOUNT",
  SERVER_ERROR = "SERVER_ERROR",
  GET_ITEM_PROTECTED = "GET_ITEM_PROTECTED",
  TEAM_IN_PROJECT_EXTENDED = "TEAM_IN_PROJECT_EXTENDED",
  SEARCH_PROJECT_RESOURCE = "SEARCH_PROJECT_RESOURCE",
  GET_ITEMS_COUNT_WITHOUT_SUCCESS = "GET_ITEMS_COUNT_WITHOUT_SUCCESS",
  UPGRADE_SUBSCRIPTION = "UPGRADE_SUBSCRIPTION",
  ACCOUNT_PAYMENT_ENABLE = "ACCOUNT_PAYMENT_ENABLE",
  ACCOUNT_MCP_ENABLE = "ACCOUNT_MCP_ENABLE",
  ACCOUNT_BY_ID = "ACCOUNT_BY_ID",
  ACCOUNT_SETUP = "ACCOUNT_SETUP",
  ACCOUNT_SETUP_STEP = "ACCOUNT_SETUP_STEP",
  ACCOUNT_COMPLETE_SETUP = "ACCOUNT_COMPLETE_SETUP",
  PAYMENT_LINK = "PAYMENT_LINK",
  SET_STRIPE_CUSTOMER_ID = "SET_STRIPE_CUSTOMER_ID",
  ATTACHMENT_VIDEO_URL_BY_ACCOUNT = "ATTACHMENT_VIDEO_URL_BY_ACCOUNT",
  TEAM_ROLES = "TEAM_ROLES",
  PROJECT_OVERVIEW_BY_USER = "PROJECT_OVERVIEW_BY_USER",
  MARK_AS_DELETED = "MARK_AS_DELETED",
  GET_ITEM_CONFIG = "GET_ITEM_CONFIG",
  GET_LAST_MILESTONE = "GET_LAST_MILESTONE",
  COMMENT_REACTION = "COMMENT_REACTION",
  COMMENT_MARK_AS_DELETED = "COMMENT_MARK_AS_DELETED",
  PROMO_CODE_CHECK = "PROMO_CODE_CHECK",
  CONVERT_ITEM_TO_EPIC = "CONVERT_ITEM_TO_EPIC",
  GET_EPIC_DETAILS = "GET_EPIC_DETAILS",
  GET_EPIC_FILES = "GET_EPIC_FILES",
  UPDATE_EPIC_STRUCTURED_DESCRIPTION = "UPDATE_EPIC_STRUCTURED_DESCRIPTION",
  DELETE_FILE_FROM_EPIC = "DELETE_FILE_FROM_EPIC",
  SPRINT_ANALYTICS_INSIGHTS = "SPRINT_ANALYTICS_INSIGHTS",
  DUPLICATE_ITEM = "DUPLICATE_ITEM",
  GET_USER_COUNTS = "GET_USER_COUNTS",
  GET_AI_CONFIG = "GET_AI_CONFIG",
  GET_AI_MODELS = "GET_AI_MODELS",
  GET_AI_MODEL_PROVIDERS = "GET_AI_MODEL_PROVIDERS",
  CREATE_AI_MODEL = "CREATE_AI_MODEL",
  DELETE_AI_MODEL = "DELETE_AI_MODEL",
  UPDATE_AI_MODEL_STATUS = "UPDATE_AI_MODEL_STATUS",
  HAS_AI_CONFIG = "HAS_AI_CONFIG",
  AI_CONFIG_UPDATE = "AI_CONFIG_UPDATE",
  AI_CONFIG_CREATE = "AI_CONFIG_CREATE",
  AI_CONFIG_TOKEN_CHECK = "AI_CONFIG_TOKEN_CHECK",
  AI_CONFIG = "AI_CONFIG",
  AI_CONFIG_PROFILE = "AI_CONFIG_PROFILE",
  AI_CONFIG_BY_ID = "AI_CONFIG_BY_ID",
  GET_AI_PROMPTS = "GET_AI_PROMPTS",
  AI_CONVERSATION_GET_OR_CREATE = "AI_CONVERSATION_GET_OR_CREATE",
  AI_CONVERSATION = "AI_CONVERSATION",
  AI_CONVERSATION_MESSAGES = "AI_CONVERSATION_MESSAGES",
  AI_CONVERSATION_MESSAGES_DELETE = "AI_CONVERSATION_MESSAGES_DELETE",
  AI_CONVERSATION_CLEAR_CONTEXT = "AI_CONVERSATION_CLEAR_CONTEXT",
  AI_PROMPT = "AI_PROMPT",
  AI_PROMPT_RUN = "AI_PROMPT_RUN",
  AI_PROMPT_ENABLED = "AI_PROMPT_ENABLED",
  AI_ACTIVITY_LOG_ACCOUNT = "AI_ACTIVITY_LOG_ACCOUNT",
  AI_ACTIVITY_LOG_ACCOUNT_DETAIL = "AI_ACTIVITY_LOG_ACCOUNT_DETAIL",
  AI_ACTIVITY_LOG_ACCOUNT_STATS = "AI_ACTIVITY_LOG_ACCOUNT_STATS",
  AI_ACTIVITY_LOG_SUPERADMIN = "AI_ACTIVITY_LOG_SUPERADMIN",
  AI_ACTIVITY_LOG_SUPERADMIN_DETAIL = "AI_ACTIVITY_LOG_SUPERADMIN_DETAIL",
  AI_ACTIVITY_LOG_SUPERADMIN_STATS = "AI_ACTIVITY_LOG_SUPERADMIN_STATS",
  ITEM_AI_ACCEPTANCE_CRITERIA = "ITEM_AI_ACCEPTANCE_CRITERIA",
  ITEM_AI_ACCEPTANCE_CRITERIA_REGENERATE = "ITEM_AI_ACCEPTANCE_CRITERIA_REGENERATE",
  AI_ACTIVITY_LOG_SUPERADMIN_SEARCH = "AI_ACTIVITY_LOG_SUPERADMIN_SEARCH",
  AI_ACTIVITY_LOG_ACCOUNT_SEARCH = "AI_ACTIVITY_LOG_ACCOUNT_SEARCH",
  GET_EXTENDED_ITEMS = "GET_EXTENDED_ITEMS",
  JIRA_SYNC_GET_BY_PROJECT = "JIRA_SYNC_GET_BY_PROJECT",
  JIRA_SYNC_CHANGE_PROJECT = "JIRA_SYNC_CHANGE_PROJECT",
  JIRA_SYNC_CHANGE_PS_TO_JIRA = "JIRA_SYNC_CHANGE_PS_TO_JIRA",
  JIRA_SYNC_CHANGE_JIRA_TO_PS = "JIRA_SYNC_CHANGE_JIRA_TO_PS",
  JIRA_SETTING_GET_BY_TEAM = "JIRA_SETTING_GET_BY_TEAM",
  JIRA_MAPPING_PS_TO_JIRA_STATUSES = "JIRA_MAPPING_PS_TO_JIRA_STATUSES",
  JIRA_MAPPING_PS_TO_JIRA_STATUS_DELETE = "JIRA_MAPPING_PS_TO_JIRA_STATUS_DELETE",
  JIRA_MAPPING_JIRA_TO_PS_STATUSES = "JIRA_MAPPING_JIRA_TO_PS_STATUSES",
  JIRA_MAPPING_JIRA_TO_PS_STATUS_DELETE = "JIRA_MAPPING_JIRA_TO_PS_STATUS_DELETE",
  JIRA_MAPPING_PS_TO_JIRA_ISSUE_TYPES = "JIRA_MAPPING_PS_TO_JIRA_ISSUE_TYPES",
  JIRA_MAPPING_PS_TO_JIRA_ISSUE_TYPE_DELETE = "JIRA_MAPPING_PS_TO_JIRA_ISSUE_TYPE_DELETE",
  JIRA_MAPPING_JIRA_TO_PS_ISSUE_TYPES = "JIRA_MAPPING_JIRA_TO_PS_ISSUE_TYPES",
  JIRA_MAPPING_JIRA_TO_PS_ISSUE_TYPE_DELETE = "JIRA_MAPPING_JIRA_TO_PS_ISSUE_TYPE_DELETE",
  JIRA_MAPPING_PS_TO_JIRA_SEVERITY_LEVEL = "JIRA_MAPPING_PS_TO_JIRA_SEVERITY_LEVEL",
  JIRA_MAPPING_PS_TO_JIRA_SEVERITY_LEVEL_DELETE = "JIRA_MAPPING_PS_TO_JIRA_SEVERITY_LEVEL_DELETE",
  JIRA_MAPPING_JIRA_TO_PS_SEVERITY_LEVEL = "JIRA_MAPPING_JIRA_TO_PS_SEVERITY_LEVEL",
  JIRA_MAPPING_JIRA_TO_PS_SEVERITY_LEVEL_DELETE = "JIRA_MAPPING_JIRA_TO_PS_SEVERITY_LEVEL_DELETE",
  CALENDAR_EVENTS = "CALENDAR_EVENTS",
  CALENDAR_EVENT_BY_ID = "CALENDAR_EVENT_BY_ID",
  GET_IDEAS = "GET_IDEAS",
  GET_IDEA_COUNTS = "GET_IDEA_COUNTS",
  RESOLVE_IDEA_ID = "RESOLVE_IDEA_ID",
  IDEA = "IDEA",
  IDEA_VOTE = "IDEA_VOTE",
  IDEA_FOLLOW = "IDEA_FOLLOW",
  IDEA_READY = "IDEA_READY",
  IDEA_CHANGE_PRIORITY = "IDEA_CHANGE_PRIORITY",
  IDEA_CHANGE_STATUS = "IDEA_CHANGE_STATUS",
  IDEA_DELETE = "IDEA_DELETE",
  IDEA_CONVERT_TO_EPIC = "IDEA_CONVERT_TO_EPIC",
  IDEA_CONVERT_TO_FEATURE = "IDEA_CONVERT_TO_FEATURE",
  IDEA_CONVERT_TO_ITEM = "IDEA_CONVERT_TO_ITEM"
}
